import { SideNavInterface } from '../../interfaces/side-nav.type';
export const ROUTES: SideNavInterface[] = [
  {
    path: 'dashboard',
    title: 'Dashboard',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'appstore',
    role: '',
    submenu: [],
  },
  // {
  //   path: '',
  //   title: 'Menu',
  //   iconType: '',
  //   iconTheme: 'outline',
  //   icon: 'bar-chart',
  //   role : 'Admin',
  //   submenu: [],
  // },
  // ADMIN ACCESS
  {
    path: '',
    title: 'User Management',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    role: 'Admin',
    submenu: [
      {
        path: 'user-management/create-user',
        title: 'Create User',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user-add',
        role: 'Admin',
        submenu: [],
      },
      {
        path: 'user-management/manage-user',
        title: 'Manage User',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'reconciliation',
        role: 'Admin',
        submenu: [],
      },
    ],
  },
  // CUSTOMER ACCESS
  {
    path: '',
    title: 'Reports',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'unordered-list',
    role: 'Customer',
    submenu: [
      {
        path: ['/reports', 'order-list', 'SalesOrder'],
        title: 'Sales Order List',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'book',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'open-orders', 'oSalesOrder'],
        title: 'Open Sales Orders',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'calendar',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'delivery-list', 'DeliveryOrder'],
        title: 'Delivery List',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'audit',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'open-delivery', 'oDeliveryOrder'],
        title: 'Open Delivery',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'container',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'invoice-list', 'ARInvoice'],
        title: 'Invoice List',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'profile',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'open-invoice', 'oARInvoice'],
        title: 'Open Invoice',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'layout',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'credit-note-open', 'ARCreditNote'],
        title: 'Credit Note-Open',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-done',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'payments', 'CustomerPayments'],
        title: 'Payments',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-protect',
        role: 'Customer',
        submenu: [],
      },
      {
        path: ['/reports', 'info-enquiry', 'InfoEnquiry'],
        title: 'Info Enquiry',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'exception',
        role: 'Customer',
        submenu: [],
      },
    ],
  },
  // SUPPLIER ACCESS
  {
    path: '',
    title: 'Reports',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'unordered-list',
    role: 'Supplier',
    submenu: [
      {
        path: ['/reports', 'order-list', 'PurchaseOrder'],
        title: 'Purchase Order List',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'book',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'open-orders', 'oPurchaseOrder'],
        title: 'Open Purchase Orders',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'calendar',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'goods-receipt-list', 'GoodsReceipt'],
        title: 'Goods Receipt List',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'audit',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'open-gr', 'oGoodsReceipt'],
        title: 'Open GR',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'container',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'invoice-list', 'APInvoice'],
        title: 'Invoice List',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'profile',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'open-invoice', 'oAPInvoice'],
        title: 'Open Invoice',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'layout',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'credit-note-open', 'APCreditNote'],
        title: 'Credit Note-Open',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-done',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'payments', 'SupplierPayments'],
        title: 'Payments',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-protect',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'shipment', 'OpenPODetailedList'],
        title: 'Shipment Management',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-protect',
        role: 'Supplier',
        submenu: [],
      },
      {
        path: ['/reports', 'info-enquiry', 'InfoEnquiry'],
        title: 'Info Enquiry',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'reconciliation',
        role: 'exception',
        submenu: [],
      },
    ],
  },
];
